import { render } from "./DeactivateFinalView.vue?vue&type=template&id=c7c189a0"
import script from "./DeactivateFinalView.vue?vue&type=script&lang=js"
export * from "./DeactivateFinalView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__